(() => {
  if (window.uchinoHeroTextFit) return;
  window.uchinoHeroTextFit = true;
  let frame;
  const fit = () => {
    const compact = window.matchMedia('(max-width: 999px)').matches;
    document.querySelectorAll('.uchino-desktop-hero .uchino-hero-description').forEach((element) => {
      element.style.removeProperty('font-size');
      if (!compact || !element.clientWidth) return;
      const style = getComputedStyle(element);
      const articleStyle = getComputedStyle(element.closest('article'));
      const contentWidth = document.documentElement.clientWidth - parseFloat(articleStyle.paddingLeft) - parseFloat(articleStyle.paddingRight);
      const available = Math.min(element.clientWidth, contentWidth) - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const measure = document.createElement('span');
      measure.textContent = element.textContent.trim();
      Object.assign(measure.style, {
        position: 'fixed', visibility: 'hidden', whiteSpace: 'nowrap',
        font: style.font, letterSpacing: style.letterSpacing,
        left: '-10000px', top: '0'
      });
      document.body.appendChild(measure);
      const width = measure.getBoundingClientRect().width;
      measure.remove();
      if (width > available && available > 0) {
        const size = Math.floor(parseFloat(style.fontSize) * (available - 1) / width * 10) / 10;
        element.style.fontSize = `${size}px`;
      }
    });
  };
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fit);
  };
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  if (document.fonts) document.fonts.ready.then(schedule);
  schedule();
})();
